<template>
	<div class="content">
		<div class="editInfor">
			<div>
				<div>
					<span class="red">*</span>手机号:
				</div>
				<div>
					<input type="text" v-model="CustomerPhone" @keypress="searchCustomers($event)" placeholder="扫描会员二维码"
						required="required" />
					<span class="err">{{$uil.checkPhone(CustomerPhone)?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>会员姓名:
				</div>
				<div>
					<input type="text" v-model="CustomerName" required="required" placeholder="会员姓名" />

					<span class="err">{{$uil.checkchinese(CustomerName,2,6)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>孩子数量:
				</div>
				<div>
					<input type="text" v-model="CustomerChild" required="required" placeholder="会员孩子数量" />

					<span class="err">{{CustomerChild>=0?'':'x'}}</span>
				</div>

				<div>
					<span class="red">*</span>孩子年龄:
				</div>
				<div>
					<input type="text" v-model="age" required="required" placeholder="孩子年龄" />

					<span class="err">{{age>=0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>孩子学校:
				</div>
				<div>
					<input type="text" v-model="school" required="required" placeholder="孩子学校" />

					<span class="err"> </span>
				</div>


				<div>
					<span class="red">*</span>会员分类:
				</div>
				<div>
					<select v-model="VipLevlID">
						<option v-for="(i,index) in vipLevl" :value="i.vipLevlID">{{i.Price +' '+i.vipTag}}</option>
					</select>
				</div>
				<div>
					<span class="red">*</span>开始时间:
				</div>
				<div>
					<input type="text" v-model="VipBeginDate" placeholder="格式:2021-01-01" />
					<span class="err">{{$uil.checkDate(VipBeginDate)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>结束时间:
				</div>
				<div>
					<input type="text" v-model="VipEndDate" placeholder="格式:2021-01-01" />
					<span class="err">{{$uil.checkDate(VipEndDate)?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>实收费:
				</div>
				<div>
					<input type="text" v-model="Disbursements" />

				</div>

				<div>
					<span class="red">*</span>送书箱:
				</div>
				<div>
					<input type="text" v-model="boxMoney" />{{'已缴'+boxMoney1}}
				</div>


				<div>
					<span class="red"></span>账户押金:
				</div>
				<div>
					<span>{{Deposit| rmb}}</span>
				</div>
				
				<div>
					<span class="red"></span>会员状态:
				</div>
				<div>
				  <select  v-model="CustomerState">
				  	<option v-for='(i,index) in state' :value="i.id">{{i.text}}</option>
				  </select>
				</div>
				<div>
					<span class="red"></span>会员负责人:
				</div>
				<div>
				   <input type="text" v-model="BelongTo" />
				</div>
				<div>
					<span class="red">{{Disbursements==0?"*":''}}</span>备注:
				</div>
				<div>
					<textarea v-model="remarks"></textarea>
					<span class="err"> </span>
				</div>

				<div>
					<span class="red">*</span>合计:
				</div>
				<div>
					<span>实收:{{Disbursements | rmb}}</span>
				</div>
				<div>
				</div>
				<div>
					<button class="button" :class="{'disabled':checkDate}" :disabled="checkDate"
						@click="editCustomer">{{ CustomerID==0?'确定':'确定'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="clear()">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import j from './j.js'
	export default j
</script>

<style>
</style>
